export const setTitle = (titleKey: any) => {
  document.title = titleKey ? (titleKey + ' | ' + process.env.applicationName) : ('' + process.env.applicationName);
};

export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};
